<script setup lang="ts">
import { Alert } from '~/composables/useAlert'
</script>

<template>
  <Teleport to="body">
    <Transition name="fade">
      <div v-if="Alert.isShow" id="layer" class="layer active">
        <div class="mask"></div>
        <div class="inner">
          <div class="popup-container">
            <div class="popup-body">
              <h2>{{ Alert.title }}</h2>
              <p>{{ Alert.message }}</p>
            </div>
            <div class="popup-footer">
              <a
                v-if="Alert.cancelText"
                @click="Alert.cancel()"
              >
                <span>{{ Alert.cancelText }}</span>
              </a>
              <a @click="Alert.confirm()">
                <span>{{ Alert.confirmText }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>